module.exports = __webpack_public_path__ + "static/img/reward_iphone.a5f1b7e7.png";